module.exports = __webpack_public_path__ + "img/LogoFinedayFullname.2cc53284.png";